module.exports = __webpack_public_path__ + "static/media/video_5.bd9957fd.mp4";